import {AES} from 'crypto-js';

export function enc(message, password){
    const result = AES.encrypt(message, password).toString();
    return result;
}
